import {
  Box,
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material'

type TimeRange = '1' | '3' | '6' | '9' | '12'
type LicenseCategory = 'Paramedic' | 'EMT' | 'AEMT' | 'Nurse' | 'Other' | 'All'

type PerformanceFiltersProps = {
  timeRange: TimeRange
  licenseCategory: LicenseCategory
  onTimeRangeChange: (value: TimeRange) => void
  onLicenseCategoryChange: (value: LicenseCategory) => void
}

export let PerformanceFilters = ({
  timeRange,
  licenseCategory,
  onTimeRangeChange,
  onLicenseCategoryChange,
}: PerformanceFiltersProps) => (
  <Card sx={{ mb: 3, p: 3 }}>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
        gap: 2,
      }}
    >
      <FormControl fullWidth>
        <InputLabel id="time-range-label">Time Range</InputLabel>
        <Select
          sx={{ bgcolor: 'background.paperDark' }}
          labelId="time-range-label"
          id="time-range-select"
          value={timeRange}
          label="Time Range"
          onChange={(e) => onTimeRangeChange(e.target.value as TimeRange)}
          aria-label="Select time range for performance data"
        >
          <MenuItem value="1">Last 1 Month</MenuItem>
          <MenuItem value="3">Last 3 Months</MenuItem>
          <MenuItem value="6">Last 6 Months</MenuItem>
          <MenuItem value="9">Last 9 Months</MenuItem>
          <MenuItem value="12">Last 12 Months</MenuItem>
        </Select>
      </FormControl>

      <FormControl fullWidth>
        <InputLabel id="license-category-label">License Category</InputLabel>
        <Select
          sx={{ bgcolor: 'background.paperDark' }}
          labelId="license-category-label"
          id="license-category-select"
          value={licenseCategory}
          label="License Category"
          onChange={(e) =>
            onLicenseCategoryChange(e.target.value as LicenseCategory)
          }
          aria-label="Select license category to analyze"
        >
          <MenuItem value="All">All</MenuItem>
          <MenuItem value="Paramedic">Paramedic</MenuItem>
          <MenuItem value="EMT">EMT</MenuItem>
          <MenuItem value="AEMT">AEMT</MenuItem>
          <MenuItem value="Nurse">Nurse</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </Select>
      </FormControl>
    </Box>
  </Card>
)

export type { TimeRange, LicenseCategory }
